import {useI18Next} from '../../../../../../common/helpers/react/hooks/useI18Next';

export function useGroupWizardTitle(isEditing: boolean): string {
    const {t} = useI18Next();

    return isEditing
        ? t('EDIT_GROUP_TITLE')
        : t('CREATE_GROUP_TITLE');
}
